import {
  CurrencyDisplay,
  CustomTable,
  PrimaryButton,
  SecondaryButton,
} from "components";
import { Dialog } from "@material-ui/core";
import {
  Box,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  Typography,
} from "@mui/material";

const ModalConfirmPaymentSalesInvoice = ({
  open,
  onClose,
  loadingButton,
  pageDetail,
  handleSubmit,
}) => {
  const detailPayment = [
    {
      invoice_number: pageDetail?.invoice_number,
      dsp_currency_symbool: pageDetail?.dsp_currency_symbool,
      value: pageDetail?.total_fee || 0,
    },
  ];
  return (
    <Dialog
      fullWidth={true}
      maxWidth="xs"
      open={open}
      onClose={onClose}
      disableEscapeKeyDown={true}
    >
      <DialogTitle>
        <Grid item>
          <Typography fontSize={18} fontWeight={800}>
            Confirm Payment Sales Invoice
          </Typography>
        </Grid>
      </DialogTitle>
      <Divider />
      <DialogContent>
        <CustomTable
          columnTable={columnTablePayment}
          data={detailPayment}
          isLoading={false}
          maxHeight={400}
        />
        <Box mt="14px">
          <Grid item>
            <Typography fontSize={14} color={"GrayText"}>
              Are you sure to confirm this data ?
            </Typography>
          </Grid>
        </Box>
      </DialogContent>
      <DialogActions>
        <SecondaryButton label="Cancel" onClick={onClose} />
        <PrimaryButton
          label={loadingButton ? "Wait" : "Confirm"}
          loading={loadingButton}
          disabled={loadingButton}
          onClick={handleSubmit}
        />
      </DialogActions>
    </Dialog>
  );
};
const columnTablePayment = [
  {
    name: "invoice_number",
    title: "Invoice Number",
  },
  {
    name: "all",
    title: "Value",
    headerAlign: "right",
    renderText: item => (
      <CurrencyDisplay
        value={item?.value}
        decimalScale={2}
        suffix=",-"
        prefix="Rp"
      />
    ),
  },
];

export default ModalConfirmPaymentSalesInvoice;
